module.exports=[
  "Academic Professor",
  "Academic Student",
  "Architect",
  "Chemist",
  "Construction",
  "Corporate Management",
  "Engineer",
  "Facility Manager / Supervisor/ Director",
  "Hospital Administrator",
  "Investigator",
  "Lab Manager / Supervisor / Director",
  "Lab Planner",
  "Medical Practitioner",
  "Project Manager / Supervisor/ Director",
  "Purchasing Agent",
  "QA / QC Manager / Supervisor / Director",
  "R&D Manager / Supervisor / Director",
  "Research Scientist",
  "Safety Risk Manager",
  "Technical Consultant",
  "Technician",
  "Other"
]
